import CurrencyInput from 'react-currency-input-field';
import { isWindows } from '../../../../../utils/isWindows';
import './SurveyQuizCoverageInput.css';

const SurveyQuizCoverageInptuLayout = props => {
  return (
    <div className={`surveyQuizCoverageInput ${props.class} w-100 p-relative mb-2`} >

         <CurrencyInput
            name="funeral_cost"
            onValueChange={(value, name) => props.handler(value)}
            allowDecimals={false}
            className="w-100 form-control"
            style={{height: 38}}
            maxLength={5}
            onDoubleClick={(event)=> event.target.select()}	
            value={props.funeral_cost}
            onFocus={(e) => props.onFocus()}
          />
          
          <span className={`p-absolute ${isWindows() ? "isWindows" : ""}`}>$</span>
    </div>
  );
};


export default SurveyQuizCoverageInptuLayout;
